import {
  DEFAULT_PAYMENT_METHODS_ORDER,
  FALLBACK_COUNTRY,
  PAYMENT_METHODS_RANKING
} from 'modules/paymentSettings/constants'
import {PaymentMethodConfiguration} from 'services/payment/paymentMethods'

import {PaymentMethodType} from '@vio/core/src/api-types/bovio/request/booking_creation'

export const isAlternativePaymentMethod = (
  paymentMethod: PaymentMethodType
) => {
  return (
    paymentMethod === PaymentMethodType.Ideal ||
    paymentMethod === PaymentMethodType.RevolutPay ||
    paymentMethod === PaymentMethodType.Paypal ||
    paymentMethod === PaymentMethodType.Klarna ||
    paymentMethod === PaymentMethodType.Vipps
  )
}

export const isWalletPaymentMethod = (paymentMethod: PaymentMethodType) => {
  return (
    paymentMethod === PaymentMethodType.ApplePay ||
    paymentMethod === PaymentMethodType.GooglePay
  )
}

const getPaymentMethodsRankingPolicy = (
  userCountry: string,
  isMobile: boolean,
  isChargeLaterEligible: boolean
) => {
  if (isChargeLaterEligible) return DEFAULT_PAYMENT_METHODS_ORDER
  const {mobile, desktop} =
    PAYMENT_METHODS_RANKING[userCountry.toUpperCase()] ||
    PAYMENT_METHODS_RANKING[FALLBACK_COUNTRY]
  return isMobile ? mobile : desktop
}

export const rankPaymentMethods = (
  availablePaymentMethods: PaymentMethodConfiguration[],
  userCountry: string,
  isMobile: boolean,
  isChargeLaterEligible: boolean
): PaymentMethodConfiguration[] => {
  const sortingPolicy = getPaymentMethodsRankingPolicy(
    userCountry,
    isMobile,
    isChargeLaterEligible
  )
  return [...availablePaymentMethods].sort(
    (a, b) =>
      (sortingPolicy.indexOf(a.type) + 1 || Number.MAX_VALUE) -
      (sortingPolicy.indexOf(b.type) + 1 || Number.MAX_VALUE)
  )
}
